import React, { useContext } from 'react';
import Flag from './Flag';
import AdventureSVG from '../img/adventure.svg';
import Capital from './Capital';
import { QuestionContext } from './context';

function Question({type, flag, capital, options, answer, handleNextButtonClick}) {
  const [, showAnswers] = useContext(QuestionContext);

  return (<>
    <img src={AdventureSVG} className='ml-auto -translate-y-20' alt='Adventure SVG' />
    {type.toLowerCase() === 'flag' && 
      <Flag flag={flag} options={options} answer={answer} />
    }
    {type.toLowerCase() === 'capital' && 
      <Capital capital={capital} options={options} answer={answer} />
    }
    {showAnswers &&
      <button onClick={handleNextButtonClick} className='text-white font-medium py-2 px-6 bg-amber-500 rounded-lg hover:bg-amber-600 shadow-sm shadow-amber-500 block absolute right-0 bottom-0 mr-6 mb-6 '>Next</button>
    }
  </>);
}

export default Question;